import React from 'react';
import { getCheckoutUrl } from '../utils/utm';

export const Navigation = () => {
  const checkoutUrl = getCheckoutUrl();

  return (
    <nav 
      data-testid="navigation-bar"
      className="bg-white border-b border-gray-100 py-5 px-8 md:px-12 sticky top-0 z-40"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div data-testid="logo" className="flex items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_e2b4f0d5-b07c-4966-bd3e-126f77b04c11/artifacts/3rgqj2ph_pedlogo.png"
            alt="Payne's Education"
            className="h-10 md:h-12 w-auto"
            data-testid="nav-logo-image"
          />
        </div>
        
        <a
          href={checkoutUrl}
          data-testid="nav-cta-button"
          className="btn-primary !py-2.5 !px-4 !text-[10px] md:!py-3.5 md:!px-6 md:!text-xs"
        >
          Get Started
        </a>
      </div>
    </nav>
  );
};
